import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _get from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

import * as objects from '../../../base/common/objects.js';
import { ICodeEditorService } from '../services/codeEditorService.js';
import { CodeEditorWidget } from './codeEditorWidget.js';
import { ICommandService } from '../../../platform/commands/common/commands.js';
import { IContextKeyService } from '../../../platform/contextkey/common/contextkey.js';
import { IInstantiationService } from '../../../platform/instantiation/common/instantiation.js';
import { INotificationService } from '../../../platform/notification/common/notification.js';
import { IThemeService } from '../../../platform/theme/common/themeService.js';
import { IAccessibilityService } from '../../../platform/accessibility/common/accessibility.js';

var EmbeddedCodeEditorWidget = /*#__PURE__*/function (_CodeEditorWidget) {
  _inherits(EmbeddedCodeEditorWidget, _CodeEditorWidget);

  var _super = _createSuper(EmbeddedCodeEditorWidget);

  function EmbeddedCodeEditorWidget(domElement, options, parentEditor, instantiationService, codeEditorService, commandService, contextKeyService, themeService, notificationService, accessibilityService) {
    var _thisSuper, _this;

    _classCallCheck(this, EmbeddedCodeEditorWidget);

    _this = _super.call(this, domElement, Object.assign(Object.assign({}, parentEditor.getRawOptions()), {
      overflowWidgetsDomNode: parentEditor.getOverflowWidgetsDomNode()
    }), {}, instantiationService, codeEditorService, commandService, contextKeyService, themeService, notificationService, accessibilityService);
    _this._parentEditor = parentEditor;
    _this._overwriteOptions = options; // Overwrite parent's options

    _get((_thisSuper = _assertThisInitialized(_this), _getPrototypeOf(EmbeddedCodeEditorWidget.prototype)), "updateOptions", _thisSuper).call(_thisSuper, _this._overwriteOptions);

    _this._register(parentEditor.onDidChangeConfiguration(function (e) {
      return _this._onParentConfigurationChanged(e);
    }));

    return _this;
  }

  _createClass(EmbeddedCodeEditorWidget, [{
    key: "getParentEditor",
    value: function getParentEditor() {
      return this._parentEditor;
    }
  }, {
    key: "_onParentConfigurationChanged",
    value: function _onParentConfigurationChanged(e) {
      _get(_getPrototypeOf(EmbeddedCodeEditorWidget.prototype), "updateOptions", this).call(this, this._parentEditor.getRawOptions());

      _get(_getPrototypeOf(EmbeddedCodeEditorWidget.prototype), "updateOptions", this).call(this, this._overwriteOptions);
    }
  }, {
    key: "updateOptions",
    value: function updateOptions(newOptions) {
      objects.mixin(this._overwriteOptions, newOptions, true);

      _get(_getPrototypeOf(EmbeddedCodeEditorWidget.prototype), "updateOptions", this).call(this, this._overwriteOptions);
    }
  }]);

  return EmbeddedCodeEditorWidget;
}(CodeEditorWidget);

EmbeddedCodeEditorWidget = __decorate([__param(3, IInstantiationService), __param(4, ICodeEditorService), __param(5, ICommandService), __param(6, IContextKeyService), __param(7, IThemeService), __param(8, INotificationService), __param(9, IAccessibilityService)], EmbeddedCodeEditorWidget);
export { EmbeddedCodeEditorWidget };